import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Table, Spinner, Alert, Button } from "react-bootstrap";
import { get } from "../../services/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import { FaPrint } from "react-icons/fa";
const CoursesParticipants = () => {
  const location = useLocation();
  const { configId, courseId, courseName, courseLevel, eventName } = location.state || {};

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParticipants = async () => {
      if (!configId || !courseId) {
        setError("Faltan datos del curso o evento.");
        setLoading(false);
        return;
      }

      try {
        const response = await get(
          `https://ectech-software.com.ar/api/academy/events/${configId}/courses/${courseId}/participants`
        );
        setData(response.data || []);
      } catch (err) {
        console.error("Error al obtener inscriptos:", err);
        setError("No se pudo cargar la lista de participantes.");
      } finally {
        setLoading(false);
      }
    };

    fetchParticipants();
  }, [configId, courseId]);



const handlePrintParticipants = async () => {
  try {
    const response = await get(
      `https://ectech-software.com.ar/api/academy/events/${configId}/courses/${courseId}/participants`
    );

    const participantsData = response.data || [];

    const doc = new jsPDF("portrait");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;
    const contentWidth = pageWidth - marginX * 2;
    let y = 20;

    // Título del evento
doc.setFontSize(20);
doc.setFont("helvetica", "bold");
const Maintitle = eventName || "Nombre del evento";
const mainTitleWidth = doc.getTextWidth(Maintitle);
doc.text(Maintitle, (pageWidth - mainTitleWidth) / 2, y);
y += 8;

// Título del curso
doc.setFontSize(16);
doc.setFont("helvetica", "bold");
const title = courseName || "Nombre del curso";
const titleWidth = doc.getTextWidth(title);
doc.text(title, (pageWidth - titleWidth) / 2, y);
y += 8;

// Subtítulo (nivel del curso)
doc.setFontSize(13);
doc.setFont("helvetica", "normal");
const subtitle = courseLevel || "";
const subtitleWidth = doc.getTextWidth(subtitle);
doc.text(subtitle, (pageWidth - subtitleWidth) / 2, y);
y += 10;


    participantsData.forEach((escuela, idx) => {
      const schoolName = escuela.school || `Escuela ${idx + 1}`;
      const participants = escuela.participants || [];

      // Comprobamos espacio
      const estimatedHeight = 12 + participants.length * 6;
      if (y + estimatedHeight > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }

      // Nombre de la escuela
      doc.setFontSize(13);
      doc.setFont("helvetica", "bold");
      doc.text(schoolName, marginX, y);
      y += 8;

      // Participantes
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      if (participants.length > 0) {
        participants.forEach(p => {
          const nameLines = doc.splitTextToSize(p, contentWidth);
          nameLines.forEach(line => {
            doc.rect(marginX, y - 4, 4, 4);
            doc.text(line, marginX + 6, y);
            y += 6;
          });
        });
      } else {
        doc.text("Sin participantes", marginX + 6, y);
        y += 6;
      }

      // Línea divisoria
      doc.setDrawColor(200);
      doc.line(marginX, y, pageWidth - marginX, y);
      doc.setDrawColor(0);
      y += 8;
    });

    doc.save(`participantes_curso_${courseId}.pdf`);
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    alert("Hubo un error al generar el PDF.");
  }
};

  

  return (
    <Container className="mt-4">
      <h1 className="text-center text-primary">
        Inscriptos en Seminarios o Congresos
      </h1>

      {loading && (
        <Spinner animation="border" role="status" className="d-block mx-auto">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      )}

      {error && (
        <Alert variant="danger" className="text-center">
          {error}
        </Alert>
      )}

      {!loading && !error && data.length > 0 && (
        <>
          <div className="d-flex justify-content-end mb-3">
            <Button variant="success" onClick={handlePrintParticipants}>
             <FaPrint /> Lista de Participantes
            </Button>
          </div>
          <Table striped bordered hover>
            <thead className="table-primary">
              <tr>
                <th>Escuela</th>
                <th>Participantes</th>
              </tr>
            </thead>
            <tbody>
              {data.map((escuela, index) => (
                <tr key={index}>
                  <td>{escuela.school}</td>
                  <td>
                    {escuela.participants.length > 0 ? (
                      <ul className="mb-0">
                        {escuela.participants.map((p, i) => (
                          <li key={i}>{p}</li>
                        ))}
                      </ul>
                    ) : (
                      <em>Sin participantes</em>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}

      {!loading && !error && data.length === 0 && (
        <Alert variant="info" className="text-center">
          No hay participantes registrados.
        </Alert>
      )}
    </Container>
  );
};

export default CoursesParticipants;
